import timezonesList from 'timezones.json';

const findIndex = utc =>
    utc.length > 1 && utc[0].substr(0, 4) === 'Etc/' ? 1 : 0;

export const timezones = {};

const localTimezonesMap = {};

for (const timezone of timezonesList) {
    if (timezone.utc.length === 0) {
        continue;
    }
    const mainName = timezone.utc[findIndex(timezone.utc)];
    if (mainName in timezones && timezone.isdst) {
        continue;
    }
    timezones[mainName] = timezone.text;
    localTimezonesMap[mainName] = mainName;
    for (const utc of timezone.utc) {
        localTimezonesMap[utc] = mainName;
    }
}

export function findTimezone(localTimezoneName) {
    return localTimezonesMap[localTimezoneName];
}

export function getLocalTimezone(defaults) {
    if (typeof Intl !== 'undefined') {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return defaults;
}
